// eslint-disable-next-line
import { h } from 'preact';
import PropTypes from 'prop-types';

const IconCopy = ({ fill, className, width, height }) => (
    <svg
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={width}
        height={height}
    >
        <path d="M39.913 19.093v3.348h3.349l-3.35-3.348zm5.312 6.123h-6.7a1.388 1.388 0 0 1-1.388-1.387V17.13H23.986v28.094h21.239V25.216zM28.79 14.356h9.657c.368-.023.752.1 1.058.407l8.088 8.085c.26.26.406.613.406.98v22.785c0 .766-.621 1.387-1.388 1.387H22.598a1.388 1.388 0 0 1-1.388-1.387V35.648H3.388A1.388 1.388 0 0 1 2 34.26V3.391c0-.766.621-1.387 1.388-1.387H19.22c.374-.029.765.093 1.077.405l8.087 8.085c.26.26.406.614.406.981v2.881zm-2.775 0v-1.493h-6.7a1.388 1.388 0 0 1-1.387-1.388V4.78H4.775v28.094H21.21v-17.13c0-.766.621-1.387 1.388-1.387h3.418zm2.955 20.855h11.472a1.388 1.388 0 1 0 0-2.775H28.97a1.388 1.388 0 1 0 0 2.775zm0 5.73h11.472a1.388 1.388 0 1 0 0-2.774H28.97a1.388 1.388 0 1 0 0 2.775zm0-11.464h11.472a1.388 1.388 0 1 0 0-2.775H28.97a1.388 1.388 0 1 0 0 2.775zM9.559 22.864a1.388 1.388 0 1 1 0-2.775h8.827a1.388 1.388 0 1 1 0 2.775H9.559zm0 5.732a1.388 1.388 0 1 1 0-2.775h8.827a1.388 1.388 0 1 1 0 2.775H9.559zm0-11.465a1.388 1.388 0 1 1 0-2.775h8.827a1.388 1.388 0 1 1 0 2.775H9.559zM20.704 6.74v3.348h3.35l-3.35-3.348z"
            fill={fill} fill-rule="nonzero" />
    </svg>

);

IconCopy.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconCopy.defaultProps = {
    fill: '#ffffff',
    className: '',
    width: 30,
    height: 30,
};

export default IconCopy;


